import db from "../driverappdb";

export const ExternalStatusRepository = {
    get: (externalStatusId) => {
        return db.externalstatuses.get(externalStatusId);
    },
    getAll: () => {
        return db.externalstatuses.toArray();
    }
};